import React from 'react';
import { Grid, Box, MenuItem, TextField } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import {
  COMMON_STYLES,
  COMMON_VALIDATION_ALIAS,
  COMMON_VALIDATION_OUTPUT_COLUMN,
  COMMON_VALIDATION_PARAM,
} from './common/Constants';
import { MultiSourceColumns } from './common/fields/MultiSourceColumns';
import { OutputColumnField } from './common/fields/OutputColumnField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'date_compare',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: ['', ''],
      outputColumn: '',
      param: 'gt',
    },
  ],
};

const comparisonOperators = [
  { value: 'gt', label: 'Greater Than (>)' },
  { value: 'lt', label: 'Less Than (<)' },
  { value: 'eq', label: 'Equal To (=)' },
  { value: 'gte', label: 'Greater Than or Equal (>=)' },
  { value: 'lte', label: 'Less Than or Equal (<=)' },
  { value: 'neq', label: 'Not Equal To (!=)' },
];

const validationSchema = {
  ...COMMON_VALIDATION_ALIAS,
  ...COMMON_VALIDATION_OUTPUT_COLUMN,
  ...COMMON_VALIDATION_PARAM('Please select comparison operator'),
  'transformations.sourceColumns': {
    validate: (value, transform) => {
      const columnErrors = value.map((col) => (!col ? 'Column is required' : ''));

      if (value.filter(Boolean).length < 2) {
        return columnErrors.map((e, i) => (i < 2 && !value[i] ? 'At least 2 columns required' : e));
      }

      return columnErrors.some(Boolean) ? columnErrors : '';
    },
  },
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    const handleColumnChange = (colIndex, value) => {
      const newTransforms = [...formField.transformations];
      const newSourceCols = [...transform.sourceColumns];
      newSourceCols[colIndex] = value;
      newTransforms[index].sourceColumns = newSourceCols;
      setFieldValue('transformations', newTransforms);
    };

    return (
      <>
        <Grid item xs={12} sm={6}>
          <MultiSourceColumns
            sourceColumns={transform.sourceColumns}
            handleColumnChange={handleColumnChange}
            headers={headers}
            disableForm={disableForm}
            errors={errors?.sourceColumns || []}
            minColumns={2}
            maxColumns={2}
          />
        </Grid>

        <Grid container spacing={2}>
          <Grid item {...COMMON_STYLES.gridItem}>
            <TextField
              select
              fullWidth
              label="Comparison Operator *"
              size="small"
              value={transform.param}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].param = e.target.value;
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              error={!!errors.param}
              helperText={errors?.param}
            >
              {comparisonOperators.map((operator) => (
                <MenuItem key={operator.value} value={operator.value}>
                  {operator.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.outputColumn}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].outputColumn = e.target.value;
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              error={!!errors.outputColumn}
              helperText={errors?.outputColumn || 'Will contain true/false comparison results'}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title="Compare Dates - Check if date1 > date2" disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        getNewTransform={() => ({
          sourceColumns: ['', ''],
          outputColumn: '',
          param: 'gt',
        })}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_DateCompare = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Compare Dates"
  />
);

export default NodeModal_DateCompare;
